import PropTypes from 'prop-types';
import { I18n } from 'i18n-js';
import { LOCAL_STORE_LANGUAGE } from 'constant';

const lang = localStorage.getItem(LOCAL_STORE_LANGUAGE) || 'se';
const i18n = new I18n();

i18n.defaultLocale = 'se';
i18n.locale = lang;
// TODO how to get locale

const en = require('./translations/en.json');
const se = require('./translations/se.json');
const empty = require('./translations/empty.json');

i18n.fallbacks = true;

const propTypes = {
  content: PropTypes.string,
  params: PropTypes.arrayOf(PropTypes.shape({})),
};

i18n.translations = {
  en,
  se,
  empty,
};

function Translate({ content = '', params = null }) {
  return i18n.t(content, params);
}

Translate.propTypes = propTypes;

export default Translate;
